import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer-section">
      <div className="footer-content">
        <div className="footer-logo">
          <img src="/myorderportal.png" alt="MyOrderPortal" className="footer-logo-image" />
        </div>
        
        <div className="footer-copyright">
          © Copyright 2026
        </div>
      </div>
    </div>
  );
};

export default Footer;
